import React from "react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/HomePage/home";
import ContactUs from "./pages/ContactUsPage/ContactUs";
import About from "./pages/Aboutpage/about";
import Showcase from "./pages/ShowcasePagesAll/Showcase_Invitation/showcase";
import SponsorsPage from "./pages/Sponsors/sponsorpage";
import ShowcasePresentations from "./pages/ShowcasePagesAll/Showcase_Presentations/showcase_presentations";
import ScorecardHome from "./pages/ScorecardPagesAll/ScorecardHome/scorecardHome";
import ScorecardInstructions from "./pages/ScorecardPagesAll/scorecardInstructions";
import ScorecardNews from "./pages/ScorecardPagesAll/scorecardNews";
import ScorecardParticipation from "./pages/ScorecardPagesAll/scorecardParticipation";
import ScorecardFAQ from "./pages/ScorecardPagesAll/scorecardFAQ";
import ScorecardAbout from "./pages/ScorecardPagesAll/scorecardAbout";
import ScorecardSubscribe from "./pages/ScorecardPagesAll/scorecardSubscribe";
import ScorecardContact from "./pages/ScorecardPagesAll/scorecardContact";
import Page404 from "./Page404";
import Header from "./pages/Navigation/header";
import Footer from "./pages/Navigation/footer";
import Map from "./pages/MapPage/map";
import DevResolution from "./devScreenRes";
import ReactGA from "react-ga4";

function GAListener() {
  const location = useLocation();

  useEffect(() => {
    const gaMeasurementId = process.env.REACT_APP_GOOGLE_ANALYTICS;
    if (gaMeasurementId) {
      console.log("Tracking page:", location.pathname);
      ReactGA.send({ hitType: "pageview", page: location.pathname });
    }
  }, [location]);

  return null;
}

function App() {
  useEffect(() => {
    const gaMeasurementId = process.env.REACT_APP_GOOGLE_ANALYTICS;
    if (gaMeasurementId) {
      ReactGA.initialize(gaMeasurementId);
      console.log("Google Analytics initialized");
    } else {
      console.warn("Google Analytics measurement ID not found. Analytics disabled.");
    }
  }, []);

  return (
    <div className="route-wrapper">
      <Router>
        <GAListener />
        <Header />
        <Routes>
          <Route path="/map" element={<Map />} />
          <Route path="/" element={<Home />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/about" element={<About />} />
          <Route path="/showcase/innovations" element={<Showcase />} />
          <Route path="/sponsors" element={<SponsorsPage />} />
          <Route
            path="/showcase/presentations"
            element={<ShowcasePresentations />}
          />
          <Route path="/scorecard" element={<ScorecardHome />} />
          <Route
            path="/scorecard/instructions"
            element={<ScorecardInstructions />}
          />
          <Route path="/scorecard/news" element={<ScorecardNews />} />
          <Route
            path="/scorecard/participation"
            element={<ScorecardParticipation />}
          />
          <Route path="/scorecard/faq" element={<ScorecardFAQ />} />
          <Route path="/scorecard/about" element={<ScorecardAbout />} />
          <Route path="/scorecard/subscribe" element={<ScorecardSubscribe />} />
          <Route path="/scorecard/contact" element={<ScorecardContact />} />
          <Route
            path="/dev/check-your-window-size"
            element={<DevResolution />}
          />
          <Route path="*" element={<Page404 />} />{" "}
          {/* 404 catch-all fallback */}
        </Routes>

        <Footer />
      </Router>
    </div>
  );
}

export default App;
